import type { ReactNode } from 'react';
import { PrimeReactProvider } from 'primereact/api';
import { ErrorBoundary } from '@/core/error-handling/ErrorBoundary';
import { QueryProvider } from './QueryProvider';
import { ReduxProvider } from './ReduxProvider';

/**
 * Nesting order per niraxobid.md 23.14: Redux -> React Query -> ErrorBoundary.
 *
 * PrimeReact's own provider sits inside, with its defaults (ripple off, as Organization Setup already sets). It is not
 * optional (2026-10-23): Dropdown, MultiSelect and AutoComplete read `context.hideOverlaysOnDocumentScrolling` on every
 * scroll of a scrolling ancestor without guarding a missing context, so without a provider that read throws and an open
 * panel never realigns -- it stayed put while the page's scroll container moved its input away.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ReduxProvider>
      <QueryProvider>
        <PrimeReactProvider value={{ ripple: false }}>
          <ErrorBoundary>{children}</ErrorBoundary>
        </PrimeReactProvider>
      </QueryProvider>
    </ReduxProvider>
  );
}
